import React from 'react';

import { Box } from '@mui/material';

const DEFAULT_MAX_LINES = 2;

interface Props {
  text: string | null;
  maxLines?: number;
  children?: React.ReactNode;
}

// Clamps long text to maxLines with an ellipsis so fixed-width table columns never force horizontal scroll.
export default function CaseClampedText({ text, maxLines = DEFAULT_MAX_LINES, children }: Props) {
  return (
    <Box
      title={text ?? undefined}
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        overflowWrap: 'anywhere',
      }}
    >
      {children ?? text}
    </Box>
  );
}
